import { render, staticRenderFns } from "./tariffList.vue?vue&type=template&id=068f344e&scoped=true"
import script from "./tariffList.vue?vue&type=script&lang=js"
export * from "./tariffList.vue?vue&type=script&lang=js"
import style0 from "./tariffList.vue?vue&type=style&index=0&id=068f344e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f344e",
  null
  
)

export default component.exports